import React, { useEffect, useState } from "react";
import { campaign_reporting } from "../../data/campaign_data";
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, Autoplay } from "swiper";
export const baseURL = `${process.env.BASE_URL}/`;

const Reporting = ({ impact }) => {
  const [filterVal, setFilterVal] = useState(null);
  function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  const [activeThumb, setActiveThumb] = useState(null);
  const [data, setData] = useState(impact);
  const [filterData, setfilterData] = useState(
    campaign_reporting.map((item) => {
      const { category } = item;
      return category;
    })
  );

  const [inputText, setInputText] = useState("");

  const handleFilter = (category) => {
    setData(impact.filter((item) => item.heading === category));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const newArray = impact.filter((item) => {
      return item.title.toLowerCase().includes(inputText);
    });
    setData(newArray);
    setInputText("");
  };

  useEffect(() => {
    setfilterData(filterData.filter(onlyUnique));
    console.log(impact.milestones)
  }, [filterData, impact.milestones]);
  const [indNum, setIndNum] = useState(0);
  return (
    <>
      {/* <!-- Activity Tab --> */}
      <div className="tab-pane fade">
        <div className=" overflow-hidden transition-shadow hover:shadow-lg mb-10 space-y-5 lg:mb-0 lg:pr-10">
          {/* <!-- Records / Filter --> */}
          <div className="flex flex-wrap">
            {data.milestones?.map((category, i) => {
              return (
                <>
                  {category.approved == true && category.sentForApproval == true ?
                    <>
                      {indNum == i ?
                        <>
                          <button
                            className={
                              filterVal === i
                                ? "dark:border-jacarta-600 group bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border px-4 py-3 border-transparent text-white dark:border-transparent"
                                : "dark:border-jacarta-600 dark:bg-jacarta-700 group dark:hover:bg-accent hover:bg-accent border-jacarta-100 mr-2.5 mb-2.5 inline-flex items-center rounded-xl border bg-white px-4 py-3 hover:border-transparent hover:text-white dark:text-white dark:hover:border-transparent"
                            }
                            key={i}
                            onClick={() => {
                              handleFilter(category.heading);
                              setFilterVal(i);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="60"
                              zoomAndPan="magnify"
                              viewBox="0 0 45 44.999999"
                              height="60"
                              preserveAspectRatio="xMidYMid meet"
                              version="1.0"
                              className={
                                filterVal === i
                                  ? "icon mr-2 h-6 w-6 fill-white"
                                  : "icon fill-jacarta-700 mr-2 h-6 w-6 group-hover:fill-white dark:fill-white"
                              }
                            >
                              <defs>
                                <clipPath id="2cd280f943">
                                  <path
                                    d="M 11.320312 36 L 25 36 L 25 45 L 11.320312 45 Z M 11.320312 36 "
                                    clipRule="nonzero"
                                  />
                                </clipPath>
                                <clipPath id="c143e4d94c">
                                  <path
                                    d="M 15 1 L 38.320312 1 L 38.320312 42 L 15 42 Z M 15 1 "
                                    clipRule="nonzero"
                                  />
                                </clipPath>
                              </defs>
                              <g clipPath="url(#2cd280f943)">
                                <path
                                  d="M 24.058594 40.53125 C 24.058594 42.953125 21.1875 44.835938 17.691406 44.835938 C 14.191406 44.835938 11.320312 42.863281 11.320312 40.53125 C 11.320312 38.914062 12.667969 37.480469 14.730469 36.671875 L 14.730469 38.734375 C 14.101562 39.183594 13.832031 39.8125 13.832031 40.441406 C 13.832031 41.964844 15.625 43.132812 17.777344 43.132812 C 19.933594 43.132812 21.726562 41.964844 21.726562 40.441406 C 21.726562 39.8125 21.367188 39.183594 20.828125 38.734375 L 20.828125 36.671875 C 22.710938 37.390625 24.058594 38.824219 24.058594 40.53125 Z M 24.058594 40.53125 "
                                  fillOpacity="1"
                                  fillRule="nonzero"
                                />
                              </g>
                              <g clipPath="url(#c143e4d94c)">
                                <path
                                  d="M 32.667969 12.003906 C 34.554688 13.976562 36.4375 16.667969 38.320312 20.886719 C 31.773438 13.976562 25.222656 25.640625 18.675781 22.589844 L 18.675781 40.082031 C 18.675781 40.710938 18.136719 41.15625 17.601562 41.15625 C 16.972656 41.15625 16.523438 40.621094 16.523438 40.082031 L 16.523438 6.355469 C 15.714844 5.996094 15.179688 5.097656 15.179688 4.199219 C 15.179688 2.945312 16.253906 1.777344 17.601562 1.777344 C 18.945312 1.777344 20.023438 2.945312 20.023438 4.199219 C 20.023438 5.097656 19.484375 5.90625 18.675781 6.355469 L 18.675781 8.777344 C 25.222656 11.914062 31.773438 0.164062 38.320312 7.070312 C 36.4375 7.519531 34.554688 9.402344 32.667969 12.003906 Z M 32.667969 12.003906 "
                                  fillOpacity="1"
                                  fillRule="nonzero"
                                />
                              </g>
                            </svg>
                            <span className="text-2xs font-medium capitalize">
                              Milestone {i + 1}
                            </span>
                          </button>
                        </> : <></>}
                    </>
                    :
                    <>
                      {indNum == i ? <>
                      </> : <></>}
                    </>}
                </>
              );
            })}
          </div>

          {/* <!-- Records --> */}

          <div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pr-10">
            {data.milestones.map((item, index) => {
              const { description, heading, milestoneDate, milestoneKpis } = item;
              let jsonData = JSON.parse(item.mileStoreReport)
              return (
                <>
                  {item.approved == true && item.sentForApproval == true ?
                    <>
                      {indNum == index ?
                        <>
                          <div
                            key={index}
                            className="dark:bg-jacarta-700 dark:border-jacarta-700
                  border-jacarta-100 rounded-2.5xl relative flex items-center
                  border bg-white p-8 transition-shadow hover:shadow-lg"
                          >
                            <div >
                              <h2
                                className="font-display text-jacarta-700 dark:hover:text-accent hover:text-accent mb-4 text-xl dark:text-white sm:text-3xl">
                                {item.heading}
                              </h2>
                              {item.milestoneKpis.map((data, i2) => (
                                <div key={i2}>
                                  <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md">
                                    {data}
                                  </h4>
                                  <span className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm">
                                    {item.description}
                                  </span>
                                </div>

                              ))}
                              {/* First Section Complete of Reporting start */}
                              <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md break-all">
                                {jsonData?.opportunities.title}
                              </h4>
                              <span
                                className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm break-all">{jsonData?.opportunities.value}
                              </span>

                              <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md break-all">
                                {jsonData?.obstacles.title}</h4>
                              <span
                                className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm break-all">{jsonData?.obstacles.value}</span>

                              <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md break-all">
                                {jsonData?.lessons.title}</h4>
                              <span
                                className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm break-all">{jsonData?.lessons.value}</span>

                              <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md break-all">
                                {jsonData?.information.title}</h4>
                              <span
                                className="dark:text-jacarta-200 text-jacarta-500 mb-3 block text-sm break-all ">{jsonData?.information.value}</span>
                              {/* First Section Complete of Reporting end  */}

                              <h4 className="bg-white py-3 text-left font-display text-jacarta-700 dark:bg-jacarta-700 dark:text-white text-md break-all">
                                Photos/Images</h4>
                            </div>
                            <div className="absolute inset-x-0 bottom-0 h-16">
                              <div className="container">
                                {/* <Thumbs_carousel /> */}
                                <Swiper
                                  modules={[FreeMode, Navigation, Thumbs]}
                                  onSwiper={setActiveThumb}
                                  loop={false}
                                  spaceBetween={10}
                                  slidesPerView="auto"
                                  breakpoints={{
                                    100: {
                                      slidesPerView: 2,
                                    },
                                    768: {
                                      slidesPerView: 3,
                                    },
                                  }}
                                  className=" full-slider-thumbs swiper-initialized swiper-horizontal swiper-pointer-events swiper-thumbs"
                                >
                                  {item.asset_list.map((item, i) => {
                                    return (
                                      <SwiperSlide
                                        className="swiper-slide cursor-pointer rounded p-5 swiper-slide-duplicate swiper-slide-duplicate-next "
                                        key={i}
                                      >
                                        <Image
                                          width={343}
                                          height={188}
                                          src={baseURL + item}
                                          className="w-full h-full object-cover rounded-lg"
                                          alt="thumb 1"
                                        />
                                        <div className="carousel-progress relative -bottom-5 z-10 -ml-5 -mr-5 h-0.5 bg-white/20 ">
                                          <div className="progress bg-accent absolute h-0.5 w-0"></div>
                                        </div>
                                      </SwiperSlide>
                                    );
                                  })}
                                </Swiper>
                              </div>
                            </div>
                          </div>
                        </> : <></>}
                    </>
                    :
                    <>
                      {indNum == index ? <>
                        No Reports Submitted Yet.
                      </> : <></>}
                    </>}
                </>
              );
            })}
          </div>

          {/* <!-- Filters --> */}
        </div>
      </div>
    </>
  );
};

export default Reporting;
